import { gql } from "@apollo/client";

export const ADD_CUSTOMER_ENQUIRY = gql`
    mutation AddCustomerEnquiry($customerEnquiry: CustomerEnquiryInputType!) {
        addCustomerEnquiry(customerEnquiry: $customerEnquiry) {
            success
            message
        }
    }
`;
